import { render, staticRenderFns } from "./SelectOtherCustomerDialog.vue?vue&type=template&id=6ba28a1d&scoped=true&lang=pug&"
import script from "./SelectOtherCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./SelectOtherCustomerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba28a1d",
  null
  
)

export default component.exports